<template>
    <IntegrationSettingsCard icon="fas fa-cogs"
                             title="Settings"
                             description="Manage general settings for the integration"
    >
        <template v-slot:body>
            <h2>API Settings</h2>
            <div class="form-group">
                <label class="font-weight-bold">API URL</label>
                <input type="text" class="form-control" v-model="configs.plenty_api_url">
                <span class="form-text text-muted">Set the URL for you plentymarkets endpoint.</span>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="font-weight-bold">API User</label>
                        <input type="text" class="form-control" v-model="configs.plenty_user">
                        <span class="form-text text-muted">Enter the username for the API.</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="font-weight-bold">API Password</label>
                        <input type="password" class="form-control" v-model="configs.plenty_pw">
                        <span class="form-text text-muted">Enter the users password.</span>
                    </div>
                </div>
            </div>

            <h2>Import Settings</h2>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="font-weight-bold">Price-IDs</label>
                        <SelectSalesPrices :available-sales-price-ids="formData.available_sales_price_ids"
                                           v-model="configs.plenty_sales_price_ids"
                        />
                        <span class="form-text text-muted">
                            Select the price ID that defines the price for the customer.
                        </span>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="font-weight-bold">Barcode-IDs</label>
                        <SelectBarcodeIds :available-barcode-ids="formData.available_barcode_ids"
                                          v-model="configs.plenty_barcode_ids"
                        />
                        <span class="form-text text-muted">Select the barcode ID that identifies EAN.</span>
                    </div>
                </div>
            </div>

            <div>
                <hr>

                <div class="d-flex flex-row justify-content-end pt-2">
                    <div>
                        <button class="btn btn-primary" :disabled="!valuesHaveChanged" @click="saveUserSettings">
                            <i class="fas fa-save"/>
                            {{ __('actions.submit') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </IntegrationSettingsCard>
</template>

<script>
import IntegrationsSettingsLayout from "@layouts/IntegrationsSettingsLayout.vue";
import IntegrationSettingsCard from "@components/Integrations/IntegrationSettingsCard.vue";
import SelectSalesPrices from "./FormElements/SelectSalesPrices.vue";
import SelectBarcodeIds from "./FormElements/SelectBarcodeIds.vue";

export default {
    components: {SelectBarcodeIds, SelectSalesPrices, IntegrationSettingsCard},
    layout: IntegrationsSettingsLayout,

    props: {
        integration: Object,
        formData: Object,
        stores: Array,
        enabledStores: Array,
    },

    data() {
        return {
            configs: this.$inertia.form(this.formData)
        }
    },

    methods: {
        saveUserSettings() {
            this.configs.post(this.$route('integration.config', [this.integration.code]))
        }
    },

    computed: {
        valuesHaveChanged() {
            return this.configs.plenty_api_url !== this.formData.plenty_api_url
                || this.configs.plenty_pw !== this.formData.plenty_pw
                || this.configs.plenty_user !== this.formData.plenty_user
                || this.configs.plenty_sales_price_ids?.toString() !== this.formData.plenty_sales_price_ids?.toString()
                || this.configs.plenty_barcode_ids?.toString() !== this.formData.plenty_barcode_ids?.toString();
        }
    }
}
</script>
